const $elements = document.querySelectorAll('[data-scroll-spy]');

const initScrollSpy = () => {
  if (!$elements) {
    return;
  }

  $elements.forEach((el) => createSpy(el));
};

const createSpy = (el) => {
  const targetItemsSelector = el.dataset.scrollSpy;

  if (!targetItemsSelector) {
    return;
  }

  const $menuItems = el.querySelectorAll(targetItemsSelector);

  if ($menuItems.length > 0) {
    createListener(el, $menuItems);
  }
};

const createListener = (parent, items) => {
  const targetSections = createTargetsArray(items);

  const observer = new IntersectionObserver((entries) => {
    const menuElement = parent.querySelector(`[href="#${entries[0].target.id}"]`);

    if (!menuElement) {
      return;
    }

    if (entries[0].isIntersecting) {
      clearAllClasses(items);
      menuElement.classList.add('is-active');
    } else {
      menuElement.classList.remove('is-active');
    }
  }, {
    threshold: [0, 0.25, 0.5, 0.75, 1],
    rootMargin: '-50% 0%',
  });


  for (let i = 0; i < targetSections.length; i++) {
    const $section = targetSections[i];

    if ($section) {
      observer.observe($section);
    }
  }
};

const createTargetsArray = (elements) => {
  const array = [];

  elements.forEach((el) => {
    let selector = el.getAttribute('href').substr(1);
    let $section = document.getElementById(selector);

    array.push($section);
  });

  return array;
};

const clearAllClasses = (elements) => {
  elements.forEach((el) => {
    el.classList.remove('is-active');
  });
};

export {initScrollSpy};
